import {Component, Input, OnInit} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";
import {WidgetResponse} from "../../models/widget-response.model";

@Component({
  selector: 'app-widget-info',
  templateUrl: './widget-info.component.html',
  styleUrls: ['./widget-info.component.scss'],
})
export class WidgetInfoComponent implements OnInit {


  @Input() widgetResponse: WidgetResponse;


  constructor(
    public commonUtils : CommonUtils,
    private modalController: ModalController,
  ) {
  }

  ngOnInit() {
  }


  close() {
    this.modalController.dismiss();
  }

  copyValue(str: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = str.toString();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();

    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (str));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });

    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.commonUtils.presentSimpleInfoToast(`Wartość '${str}' skopiowana do schowka`, 'bottom', 2000);
    }
}
